<template lang="pug">
  .post-heading(v-if="heading || subHeading")
    h3.is-size-4-desktop.is-size-5-tablet.is-size-6-mobile(v-if="heading") {{ heading }}
    h4.is-size-6-desktop.is-size-7-touch.uppercase.is-primary(v-if="subHeading") {{ subHeading }}
</template>

<script>
export default {
  name: 'Heading',
  props: {
    heading: {
      type: String
    },
    subHeading: {
      type: String
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.post-heading
  margin-top: -10px
  margin-bottom: .5rem
  .is-primary
    color: $isserstedt-blue1
  h3
    margin-bottom: 0
    color: $isserstedt-blue1
    font-weight: 600
  h4
    color: $isserstedt-blue1
    margin-bottom: 0
    font-weight: 450
    letter-spacing: 0
</style>
